import { defaultEmployee, EmployeeDto } from 'src/dtos/employee/employeeDto';
import { defaultHrmEmpShiftDto, HrmEmpShiftDto } from 'src/dtos/hrmEmpShift/hrmEmpShiftDto';
import { defaultHrmWorkShiftDto, HrmWorkShiftDto } from 'src/dtos/hrmWorkShift/hrmWorkShiftDto';

/** 사원 한 명의 근무조 배정 전체 저장 요청이다. */
export interface HRM2120_R01Dto {
    empNo: string; // 저장 대상 사원번호
    hrmEmpShiftDtoList: HRM2120_R01DetailDto[]; // 저장 후 남길 배정 전체
}
/** 일괄 배정 방식이다. */
export type HRM2120_R01BulkType = 'FIX' | 'ROT' | 'ROTA' | 'ROTB';
/** 조회된 사원에 적용할 일괄 배정 요청이다. */
export interface HRM2120_R01BulkParams {
    bulkEmpNoList: string[]; // 화면 순서의 사원번호
    bulkStartDt: string; // 적용시작일
    bulkType: HRM2120_R01BulkType; // 배정 방식
    bulkShiftCd: string; // FIX일 때의 근무조 코드
}
/** 기준일의 근무조 정보가 포함된 사원 행이다. */
export interface HRM2120_R01HeaderDto extends EmployeeDto {
    orgNm: string; // 부서명
    positionNm: string; // 직위명
    baseAssignType: string; // 기준일의 배정 방식
    baseRotGroup: string; // 기준일의 교대조
    baseShiftCd: string; // 기준일 근무조 코드
    baseShiftNm: string; // 기준일 근무조명
    isBaseShiftNight: boolean; // 기준일 야간 근무조이면 true
    assignText: string; // 배정 설명
}
/** 공통 그리드의 신규 행 상태를 표현하는 화면 전용 행 타입이다. */
export interface HRM2120_R01HeaderGridRow extends HRM2120_R01HeaderDto {
    inserted?: boolean; // 공통 그리드에서 신규 행인지 판별할 때만 사용
}
/** 근무조 배정 이력 행이다. */
export interface HRM2120_R01DetailDto extends HrmEmpShiftDto {}
/** 저장된 배정으로 계산한 하루 근무조이다. */
export interface HRM2120_R01CalendarDto extends HrmWorkShiftDto {
    workDt: string; // 근무 날짜
    isNightShift: boolean; // 야간 근무조이면 true
}

/** 사원 목록 기본 행이다. */
export const defaultHRM2120_R01HeaderDto: HRM2120_R01HeaderDto = {
    ...defaultEmployee,
    orgNm: '',
    positionNm: '',
    baseAssignType: '',
    baseRotGroup: '',
    baseShiftCd: '',
    baseShiftNm: '',
    isBaseShiftNight: false,
    assignText: '',
};
/** 배정 이력 기본 행이다. */
export const defaultHRM2120_R01DetailDto: HRM2120_R01DetailDto = { ...defaultHrmEmpShiftDto };
/** 달력 기본 칸이다. */
export const defaultHRM2120_R01CalendarDto: HRM2120_R01CalendarDto = {
    ...defaultHrmWorkShiftDto,
    workDt: '',
    isNightShift: false,
};
/** 빈 저장 요청이다. */
export const defaultHRM2120_R01Dto: HRM2120_R01Dto = {
    empNo: '',
    hrmEmpShiftDtoList: [],
};
